import React from 'react'

const BusinessNeeds = () => {
  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
          >
            A pioneering fintech company, having already modernized 150+ banks globally, faced the challenge of
            building their next-generation platform to liberate financial institutions from legacy IT systems.
            Their existing infrastructure couldn't scale to millions of concurrent users, lacked the flexibility
            for personalized banking experiences, and struggled with complex third-party integrations. Traditional
            monolithic architectures created deployment bottlenecks, and the inability to leverage cloud-native
            technologies limited their competitive advantage in the rapidly evolving digital banking landscape.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li>Need to handle 2 million peak concurrent users and 500,000+ daily active users with sub-3 second response times</li>
            <li>Legacy monolithic architecture preventing rapid feature deployment and scaling</li>
            <li>Complex integration requirements with diverse core banking systems and third-party financial service providers</li>
            <li>Inability to deliver personalized customer experiences based on behavioral patterns and transaction data</li>
            <li>Security challenges requiring OAuth 2.0 implementation with robust authentication and authorization</li>
            <li>Need for cloud-native architecture leveraging AWS services for global scalability</li>
            <li>Requirement for automated scaling to handle unpredictable traffic patterns during financial events</li>
            <li>Event-driven design needed for real-time transaction processing and notifications</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BusinessNeeds
